module.exports = __webpack_public_path__ + "static/media/tecnoparque.1e3f38f8.png";